var o={userMenuDropdown:"lds-user-menu-dropdown",content:"lds-user-menu-dropdown--content",open:"lds-user-menu-dropdown--open",group:"lds-user-menu-dropdown--group",last:"lds-user-menu-dropdown--last"};export{o as default};
